(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/game-links/assets/javascripts/game-links.js') >= 0) return;  svs.modules.push('/components/components/game-links/assets/javascripts/game-links.js'); 
var svs = svs || {};

(function(svs, _) {
  'use strict';

  svs.components.GameLinks = function(element, options) {
    var $el = element,
      el = $el.get(0),
      templateToUse = options.template,
      products = options.products,
      syndicateId = options.syndicateId,
      onFileSelected = options.onFileSelected;

    function render() {
      if (templateToUse && templateToUse === 'startpage-desktop') {
        $el.html(
          svs.components.game_links.templates.game_links_startpage_desktop(
            orderLinks(products)
          )
        );
      } else if (templateToUse && templateToUse === 'syndicate-games') {
        $el.html(
          svs.components.game_links.templates.game_links_syndicate_games({
            products: orderLinks(products),
            syndicateId: syndicateId
          })
        );
      } else {
        $el.html(
          svs.components.game_links.templates.game_links(orderLinks(products))
        );
      }
    }

    function orderLinks(gameLinks) {
      return _.filter(gameLinks, function(gameLink) {
        var shouldOnlyBeSeenOnDesktop =
            gameLink.formfactor === 'desktop' &&
            svs.core.detect.formfactor.mobile(),
          isConnectedAndEnabled = gameLink.ftName
            ? gameLink.ftName.length > 2
              ? svs.core.detect.feature(gameLink.ftName)
              : true
            : true;
        return !shouldOnlyBeSeenOnDesktop && isConnectedAndEnabled;
      });
    }

    render();

    if (onFileSelected) {
      var formElement = el.querySelector('form');
      el.querySelector('input[type="file"]').addEventListener(
        'change',
        function() {
          onFileSelected(formElement);
        }
      );
    }
  };
})(svs, _);

 })(window);